export default __webpack_public_path__ + "static/media/page.82281641.svg";